import { useCallback } from 'react';

import { MAX_TABLE_COLUMNS, Table } from './table.constants';
import {
  addToLeft,
  addToRight,
  canShowRemoveColumn,
  removeColumn,
} from './table-settings-column.utils';
import {
  DropdownDivider,
  DropdownItem,
} from 'approot/shared/dropdown/dropdown-item.style';
import TablePropertiesSettings from './table-properties-settings';
import {
  AnswerMap,
  updateAnswerMapAfterColumnDelete,
  updateAnswerMapAfterColumnInsert,
} from '../shared/logic/table-answer-map';

type Props = {
  colIndex: number;
  table: Table;
  answerMap: AnswerMap;
  onMenuToggle: (isOpen: boolean) => void;
  handleUpdateTable: (table: Table, answers?: AnswerMap) => void;
};

const TableSettingsColumn = ({
  colIndex,
  table,
  answerMap,
  onMenuToggle,
  handleUpdateTable,
}: Props) => {
  const canAddToRight = table.rows[0].cells.length < MAX_TABLE_COLUMNS;
  const canAddToLeft = table.rows[0].cells.length < MAX_TABLE_COLUMNS;
  const canRemove = canShowRemoveColumn(table.rows);

  const handleRemove = useCallback(() => {
    handleUpdateTable(
      removeColumn(table, colIndex),
      updateAnswerMapAfterColumnDelete(answerMap, colIndex)
    );
  }, [colIndex, table, answerMap, handleUpdateTable]);

  const handleAddToLeft = useCallback(() => {
    handleUpdateTable(
      addToLeft(table, colIndex),
      updateAnswerMapAfterColumnInsert(answerMap, colIndex - 1)
    );
  }, [colIndex, table, answerMap, handleUpdateTable]);

  const handleAddToRight = useCallback(() => {
    handleUpdateTable(
      addToRight(table, colIndex),
      updateAnswerMapAfterColumnInsert(answerMap, colIndex)
    );
  }, [colIndex, table, answerMap, handleUpdateTable]);

  return (
    <TablePropertiesSettings onMenuToggle={onMenuToggle}>
      {canAddToLeft && (
        <DropdownItem onClick={handleAddToLeft}>Add column left</DropdownItem>
      )}
      {canAddToRight && (
        <DropdownItem onClick={handleAddToRight}>Add column right</DropdownItem>
      )}
      {canRemove && (canAddToLeft || canAddToRight) && <DropdownDivider />}
      {canShowRemoveColumn(table.rows) && (
        <DropdownItem $isNegative onClick={handleRemove}>
          Remove column
        </DropdownItem>
      )}
    </TablePropertiesSettings>
  );
};

export default TableSettingsColumn;
